const swapIndexes = [0, 23, 29, 15, 17, 13, 7, 1, 9, 4, 3, 20, 10, 28, 6, 8, 25, 26, 18, 24, 11, 14, 5, 27, 2, 21, 22, 16, 19, 12]

const characterIds = {
    "MARIO": 0, "FOX": 1, "CPTFALCON": 2, "DK": 3, "KIRBY": 4, "BOWSER": 5,
    "LINK": 6, "SHEIK": 7, "NESS": 8, "PEACH": 9, "POPO": 10, "PIKACHU": 11,
    "SAMUS": 12, "YOSHI": 13, "JIGGLYPUFF": 14, "MEWTWO": 15, "LUIGI": 16,
    "MARTH": 17, "ZELDA": 18, "YLINK": 19, "DOC": 20, "FALCO": 21, "PICHU": 22,
    "GAMEANDWATCH": 23, "GANONDORF": 24, "ROY": 25
};


// Apply digit permutation
function applyPermutation(numericSeed) {
    let digits = numericSeed.split('');
    let permuted = new Array(digits.length);

    for (let i = 0; i < digits.length; i++) {
        let swapIndex = swapIndexes[i % swapIndexes.length]; // Cycle through swapIndexes
        permuted[i] = digits[swapIndex % digits.length]; // Ensure within bounds
    }

    return permuted.join('');
}

// Reverse digit permutation
function reversePermutation(permutedSeed) {
    let digits = permutedSeed.split('');
    let original = new Array(digits.length);

    for (let i = 0; i < digits.length; i++) {
        let swapIndex = swapIndexes[i % swapIndexes.length];
        original[swapIndex % digits.length] = digits[i];
    }

    return original.join('');
}

// Feistel round function
function feistelRound(data, key) {
    let num = (data ^ key) & 0xFFFF;
    num = ((num << 3) | (num >>> 13)) & 0xFFFF;
    return num;
}

// Feistel encryption (4 rounds on 16-bit blocks)
function feistelEncrypt(binaryStr, keys) {
    let encryptedBinary = '';
    for (let i = 0; i < binaryStr.length; i += 16) {
        let block = binaryStr.slice(i, i + 16).padEnd(16, '0');
        let left = parseInt(block.slice(0, 8), 2);
        let right = parseInt(block.slice(8, 16), 2);

        for (let j = 0; j < 4; j++) {
            let temp = right;
            right = (left ^ feistelRound(right, keys[j])) & 0xFF;
            left = temp;
        }

        encryptedBinary += left.toString(2).padStart(8, '0') + right.toString(2).padStart(8, '0');
    }
    return encryptedBinary;
}

// Feistel decryption (4 rounds on 16-bit blocks, reverse order)
function feistelDecrypt(binaryStr, keys) {
    let decryptedBinary = '';
    for (let i = 0; i < binaryStr.length; i += 16) {
        let block = binaryStr.slice(i, i + 16);
        let left = parseInt(block.slice(0, 8), 2);
        let right = parseInt(block.slice(8, 16), 2);

        for (let j = 3; j >= 0; j--) {
            let temp = left;
            left = (right ^ feistelRound(left, keys[j])) & 0xFF;
            right = temp;
        }

        decryptedBinary += left.toString(2).padStart(8, '0') + right.toString(2).padStart(8, '0');
    }
    return decryptedBinary;
}

const feistelKeys = [0x3A, 0x7C, 0x15, 0x9B];

export function encodeSeed(selectedCharacter, selectedCostumeId, selectedStageId, selectedMoveId, stats) {
    let binarySeed = '';
    //console.log(selectedCostumeId);
    binarySeed += (selectedCostumeId || 0).toString(2).padStart(3, '0');
    binarySeed += (characterIds[selectedCharacter] || 0).toString(2).padStart(5, '0');
    binarySeed += (selectedStageId || 0).toString(2).padStart(3, '0');
    binarySeed += ((selectedMoveId || -1) + 1).toString(2).padStart(9, '0');

    Object.keys(stats).map((stat) => {
        binarySeed += (stats[stat] || 0).toString(2).padStart(7, '0');
    });

    while (binarySeed.length % 16 !== 0) {
        binarySeed += 1; // Random 0 or 1 padding
    }


    let scrambledBinary = feistelEncrypt(binarySeed, feistelKeys);
    
    let numericSeed = '';
    for (let i = 0; i < scrambledBinary.length; i += 8) {
        numericSeed += parseInt(scrambledBinary.slice(i, i + 8), 2).toString().padStart(3, '0');
    }

    // Apply predefined arbitrary permutation
    let permutedSeed = applyPermutation(numericSeed);

    return permutedSeed;
}

export function decodeSeed(seed) {
    // Reverse predefined arbitrary permutation
    let originalNumericSeed = reversePermutation(seed);

    let binarySeed = '';
    for (let i = 0; i < originalNumericSeed.length; i += 3) {
        binarySeed += parseInt(originalNumericSeed.slice(i, i + 3), 10).toString(2).padStart(8, '0');
    }

    let originalBinary = feistelDecrypt(binarySeed, feistelKeys);
    let index = 0;
    let config = {};

    config.decodedSelectedCostumeId = parseInt(originalBinary.slice(index, index + 3), 2);
    index += 3;
    const characterIndex = parseInt(originalBinary.slice(index, index + 5), 2);
    config.decodedSelectedCharacter = Object.keys(characterIds).find(key => characterIds[key] === characterIndex) || null;
    index += 5;
    config.decodedSelectedStageId = parseInt(originalBinary.slice(index, index + 3), 2);
    index += 3;
    config.decodedSelectedMoveId = parseInt(originalBinary.slice(index, index + 9), 2) - 1;
    index += 9;

    config.decodedStats = [];
    for (let i = 0; i < 7; i++) {
        
        config.decodedStats.push(parseInt(originalBinary.slice(index, index + 7), 2));
        index += 7;
    }

    return config;
}
